module.exports = __webpack_public_path__ + "media/music/piano_chords_8-e7dfb17b.mp3";